"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

var _formToObject = _interopRequireDefault(require("form-to-object"));

var _formUrlencoded = _interopRequireDefault(require("form-urlencoded"));

var _helpers = require("utils/helpers");

var MiniCart = /*#__PURE__*/function () {
  function MiniCart(component) {
    (0, _classCallCheck2["default"])(this, MiniCart);
    this.dom = {
      $component: component,
      $close: Array.from(component.querySelectorAll('.js-mini-cart-close')),
      $headerShow: Array.from(document.querySelectorAll('.js-header-show-mini-cart')),
      $content: component.querySelector('.js-mini-cart-ajax-content'),
      $counts: Array.from(document.querySelectorAll('.js-mini-cart-count')),
      $increaseButton: Array.from(document.querySelectorAll('.js-mini-cart-increase')),
      $decreaseButton: Array.from(document.querySelectorAll('.js-mini-cart-decrease'))
    }, this.state = {
      open: false,
      animating: false,
      openDuration: 500,
      closeDuration: 750,
      activeClass: 'is-active',
      parser: new DOMParser(),
      isShitBrowser: (0, _helpers.isOldIE)()
    };
    this.toggleHandler = this.toggle.bind(this);
    this.keydownHandler = this.onKeydown.bind(this);
    this.updateCartHandler = this.update.bind(this);
    this.increaseHandler = this.increase.bind(this);
    this.decreaseHandler = this.decrease.bind(this);
    this.clickHandler = this.close.bind(this);
    this.mount();
  }

  (0, _createClass2["default"])(MiniCart, [{
    key: "increase",
    value: function increase(event) {
      var dom = this.dom,
          state = this.state;
      console.log('increase');

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      (0, _axios["default"])({
        method: 'post',
        url: event.currentTarget.getAttribute("href")
      }).then(function (response) {
        console.log(response);
        var customEvent = new CustomEvent('updateMiniCart', {
          detail: response.data
        });
        document.dispatchEvent(customEvent);
      })["catch"](function (response) {
        console.log(response);
      });
    }
  }, {
    key: "decrease",
    value: function decrease(event) {
      var dom = this.dom,
          state = this.state;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      (0, _axios["default"])({
        method: 'post',
        url: event.currentTarget.getAttribute("href")
      }).then(function (response) {
        //console.log(response);
        var customEvent = new CustomEvent('updateMiniCart', {
          detail: response.data
        });
        document.dispatchEvent(customEvent);
      })["catch"](function (response) {
        console.log(response);
      });
    }
  }, {
    key: "mount",
    value: function mount() {
      var _this = this;

      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('MiniCart : connect', this);
      document.addEventListener('keydown', this.keydownHandler);
      document.addEventListener('updateMiniCart', this.updateCartHandler);
      dom.$increaseButton.forEach(function ($el) {
        return $el.addEventListener('click', _this.increaseHandler);
      });
      dom.$decreaseButton.forEach(function ($el) {
        return $el.addEventListener('click', _this.decreaseHandler);
      });
      dom.$close.forEach(function ($el) {
        return $el.addEventListener('click', _this.clickHandler);
      });
      console.log((0, _helpers.isOldIE)());

      if (!state.isShitBrowser) {
        dom.$headerShow.forEach(function ($element) {
          return $element.addEventListener('click', _this.toggleHandler);
        });
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _this2 = this;

      var self = this;
      var dom = this.dom;
      console.log('MiniCart : connect', this);
      dom.$headerShow.forEach(function ($element) {
        return $element.removeEventListener('click', _this2.toggleHandler);
      });
      document.removeEventListener('keydown', this.keydownHandler);
      document.removeEventListener('updateMiniCart', this.updateCartHandler);
      dom.$increaseButton.forEach(function ($el) {
        return $el.removeEventListener('click', _this2.increaseHandler);
      });
      dom.$decreaseButton.forEach(function ($el) {
        return $el.removeEventListener('click', _this2.decreaseHandler);
      });
      dom.$close.forEach(function ($el) {
        return $el.removeEventListener('click', _this2.clickHandler);
      });
    }
  }, {
    key: "toggle",
    value: function toggle(event) {
      var dom = this.dom,
          state = this.state;
      console.log('MiniCart : toggle', this);

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (state.open) {
        this.close();
      } else {
        this.open();
      }
    }
  }, {
    key: "open",
    value: function open() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('MiniCart : open', this);

      if (!state.animating) {
        state.animating = true;
        dom.$component.setAttribute('aria-hidden', false);
        setTimeout(function () {
          dom.$component.classList.add(state.activeClass);
          dom.$headerShow.forEach(function ($element) {
            return $element.classList.add(state.activeClass);
          });
        }, 25);
        setTimeout(function () {
          state.open = true;
          state.animating = false;
          self.notify('open');
        }, state.openDuration);
      }
    }
  }, {
    key: "close",
    value: function close() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('MiniCart : close', this);

      if (!state.animating) {
        state.animating = true;
        setTimeout(function () {
          dom.$component.classList.remove(state.activeClass);
          dom.$headerShow.forEach(function ($element) {
            return $element.classList.remove(state.activeClass);
          });
        }, 25);
        setTimeout(function () {
          dom.$component.setAttribute('aria-hidden', true);
          state.open = false;
          state.animating = false;
          self.notify('close');
        }, state.closeDuration);
      }
    }
  }, {
    key: "notify",
    value: function notify(action) {
      var dom = this.dom,
          state = this.state;
      console.log('MiniCart : notify', this);
      var minicartEvent = new CustomEvent("minicart:".concat(action));
      document.dispatchEvent(minicartEvent);
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      var state = this.state;
      console.log('MiniCart : onKeydown', this, event);
      var escape = event.keyCode === 27;

      if (state.open && escape) {
        this.close();
      }
    }
  }, {
    key: "update",
    value: function update(event) {
      var _this3 = this;

      var dom = this.dom,
          state = this.state;
      console.log('MiniCart : update', this, event);
      var data = event.detail;
      var html = state.parser.parseFromString(data, 'text/html');

      if (html.querySelector('.MiniCart__empty')) {
        dom.$headerShow.forEach(function ($element) {
          return $element.classList.remove(state.visibleClass);
        });
        setTimeout(function () {
          var content = html.querySelector('.js-mini-cart-ajax-content').innerHTML;
          dom.$content.innerHTML = content;
          dom.$counts.forEach(function ($count) {
            return $count.innerHTML = '0';
          });
        }, state.closeDuration);
        this.close();
      } else {
        var content = html.querySelector('.js-mini-cart-ajax-content').innerHTML;
        var total = html.querySelector('.js-mini-cart-total').innerHTML;
        var count = html.querySelector('.js-mini-cart-count').innerHTML;
        dom.$content.innerHTML = content;
        dom.$counts.forEach(function ($count) {
          return $count.innerHTML = count;
        });
        dom.$increaseButton.forEach(function ($el) {
          return $el.removeEventListener('click', _this3.increaseHandler);
        });
        dom.$decreaseButton.forEach(function ($el) {
          return $el.removeEventListener('click', _this3.decreaseHandler);
        });
        dom.$increaseButton = Array.from(document.querySelectorAll('.js-mini-cart-increase'));
        dom.$decreaseButton = Array.from(document.querySelectorAll('.js-mini-cart-decrease'));
        dom.$increaseButton.forEach(function ($el) {
          return $el.addEventListener('click', _this3.increaseHandler);
        });
        dom.$decreaseButton.forEach(function ($el) {
          return $el.addEventListener('click', _this3.decreaseHandler);
        });
        this.open();
      }

      var mountComponentsEvent = new CustomEvent('theme:refreshComponents', {
        detail: {
          scope: dom.$content
        }
      });
      document.dispatchEvent(mountComponentsEvent);
    }
  }]);
  return MiniCart;
}();

exports["default"] = MiniCart;